/** 기사명세서 행 — 거래처상호 */
export function getStatementRowCompany(r: any): string {
  return String((r && (r.company || r['거래처상호'])) || '').trim();
}

/** 기사명세서 행 — 품명 */
export function getStatementRowItemName(r: any): string {
  return String((r && (r.itemName || r['품명'] || r['ITEMNAME'] || r['item'])) || '').trim();
}

/** 한국운수·화물공제보험 공제 행 여부 */
export function isHankookTransportDeductionRow(r: any): boolean {
  const company = getStatementRowCompany(r);
  const item = getStatementRowItemName(r).replace(/\s+/g, '');
  return company === '화물공제보험' || item === '한국운수';
}

/**
 * 기사명세서 공급자별 행 필터
 * - 성우로지스: 화물공제보험 거래처 또는 품명 '한국운수' 행 제외
 * - 한국운수: 화물공제보험 + 품명 '한국운수' 행만 포함 (해당 거래처가 있을 때)
 */
export function filterDriverStatementRows(rows: any[], supplierName: string): any[] {
  const list = Array.isArray(rows) ? rows : [];
  const supplier = (supplierName || '').replace(/\s+/g, '');

  if (/성우로지스/.test(supplier)) {
    return list.filter((r) => !isHankookTransportDeductionRow(r));
  }

  if (/한국운수/.test(supplier)) {
    const hasInsurance = list.some((r) => getStatementRowCompany(r) === '화물공제보험');
    if (!hasInsurance) return list;
    return list.filter(
      (r) =>
        getStatementRowCompany(r) === '화물공제보험' &&
        getStatementRowItemName(r).replace(/\s+/g, '') === '한국운수'
    );
  }

  return list;
}
